import { Alert, Loader } from '@mantine/core';
import type { ReactNode } from 'react';
import { errorMessage } from './errors';

export interface QueryStateProps {
  error: unknown;
  /** Data is still loading. Without children the spinner shows until there is an error. */
  isPending?: boolean;
  /** Rendered once the query has data. */
  children?: () => ReactNode;
  /** The error alert's heading. */
  title?: string;
  /** The app's text for a failed call; defaults to the shared errorMessage. */
  describeError?: (e: unknown) => string;
}

/** Error alert, loading spinner, or the children once data is in. */
export function QueryState({
  error,
  isPending = false,
  children,
  title,
  describeError = errorMessage,
}: QueryStateProps) {
  if (error)
    return (
      <Alert color="red" title={title}>
        {describeError(error)}
      </Alert>
    );
  if (isPending || !children) return <Loader size="sm" aria-label="Loading" />;
  return <>{children()}</>;
}
